import React, { useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons'

import { CONTAINER_ID, registersEmployer } from './useEmployerMatching'

// Double the Donation's employer search. Tailwind twin: donate_v7/EmployerMatching.jsx.

const HEADING_ID = 'employer-matching-heading'

const EmployerMatching = ({ i18n, employerMatching, shares }) => {
  const { enabled, failed, loaded, companyName } = employerMatching

  useEffect(() => {
    if (enabled && !failed && loaded) employerMatching.init()
  }, [ loaded ])

  if (!enabled || failed) return null

  // Dimmed rather than unmounted, which would lose the plugin's selection.
  const inactive = !registersEmployer(shares)

  return (
    // aria-labelledby: the plugin injects its field after mount, so no <label>.
    <div
      role="group"
      aria-labelledby={HEADING_ID}
      aria-disabled={inactive || undefined}
      className={
        'mb-3 employer-matching border border-primary rounded-3 bg-primary-subtle p-3' +
        (inactive ? ' opacity-50 pe-none' : '')
      }
    >
      <div className="text-center mb-2">
        <h3 id={HEADING_ID} className="h6 mb-1">
          {i18n.t('employer_matching.heading')}
        </h3>
        <p className="small text-muted mb-0">
          {i18n.t('employer_matching.description')}
        </p>
      </div>
      {/* A disabled fieldset keeps keyboard users out too; `inert` is Safari 15.5+. */}
      <fieldset disabled={inactive}>
        <div id={CONTAINER_ID}></div>
      </fieldset>
      {/* Mounted even when empty so AT announces the change. */}
      <p
        role="status"
        aria-live="polite"
        className={companyName ? 'small fw-semibold mt-2 mb-0' : 'visually-hidden'}
      >
        {companyName && <>
          <FontAwesomeIcon icon={faCircleCheck} className="text-success me-2" />
          {i18n.t('employer_matching.selected', { company: companyName })}
        </>}
      </p>
    </div>
  )
}

export default EmployerMatching
